var app = angular.module("leonardo");

var ReportsStatisticListFilters = function(
  $scope,
  $state,
  $controller,
  $timeout,
  $rootScope,
  ReportService,
  WorkFlowService,
  WorkFlowInstanceService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersStatistic;

  $scope.group_options.push({id: 'managed_by', name: 'Managed By'});

  $scope.filters_options = [];

  $scope.initOptions = function() {
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'with_deleted',
        name: 'Include Deleted Items',
        label: 'Include Deleted Items',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'workflow',
        name: 'Workflow',
        label: 'Workflow',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Workflow',
        condition: true,
        required: true,
        service: WorkFlowService,
        conflicts: []
      },
      {
        id: 'status',
        name: 'Status',
        label: 'Status',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Status',
        condition: true,
        required: false,
        options: WorkFlowInstanceService.STATUS_OPTIONS_REPORTS,
        conflicts: []
      },
      // {
      //   id: 'fields_active',
      //   name: 'Fields To Show',
      //   label: 'Fields To Show',
      //   inline: false,
      //   type: 'columns',
      //   placeholder: 'Select Fields',
      //   condition: true,
      //   options: ReportService.fieldsStatisticReport,
      //   conflicts: []
      // },
    ]);
  };

  $scope.initOptions();

  WorkFlowService.getlist({limit:1, essential: true, noerror: true}).then(function (data) {
    var results = data.results ? data.results : data;
    var workflow = results.length > 0 ? results[0].id : null;
    if ($scope.filters_name !== 'filters_report') {
      var filters = $scope.filterService.hasFilter($scope.filters_name) ? $scope.filterService.getFilter($scope.filters_name) : [];

      if (!angular.isArray(filters)) {
        filters = filters.split(',');
      }

      angular.forEach($scope.filterService.filters, function (value, key) {
        if (!_.contains(filters, key) && $scope.isValid(key)) {
          filters.push(key);
        }
      });

      if (!$scope.filterService.hasFilter('workflow')) {
        $scope.filterService.setFilter('workflow', workflow, true);
        if (!_.contains(filters, 'workflow')) {
          filters.unshift('workflow');
        }
      }

      $scope.filterService.setFilter($scope.filters_name, filters, true);
    }
    $rootScope.$broadcast('filters-report:initialized');
  });


  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_DYNAMIC_FORM_STATISTIC);
  }, 100);

};

app.controller('ReportsStatisticListFilters', [
  '$scope',
  '$state',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  'WorkFlowService',
  'WorkFlowInstanceService',
  ReportsStatisticListFilters
]);
